<template>
  <div id="april2023" class="202304 pt-6 lg:pt-12">
    <main class="main mx-auto">
      <section class="z-0 mb-16 lg:mb-0">
        <div class="lg:mb-6">
          <img src="~@/assets/images/202304/head-head.png" class="object-contain hidden lg:block">
          <img src="~@/assets/images/202304/head-mobile.png" class="object-contain lg:hidden">
        </div>
        <div class="lg:hidden">
          <img src="~@/assets/images/202304/head-kids.png" class="object-contain">
        </div>
        <div>
          <img src="~@/assets/images/202304/head-act.png" class="object-contain">
        </div>
        <div class="relative">
          <div class="relative z-0">
            <img src="~@/assets/images/202304/head-bg.png" class="object-contain z-0">
          </div>
          <div class="flex absolute w-3/5 lg:w-1/2 girls justify-center items-center">
            <div class="px-4 title">
              <img src="~@/assets/images/202304/head-title2.png" class="object-contain">
            </div>
            <div class="px-4 z-0 girl-img">
              <img src="~@/assets/images/202304/head-girl.png" class="object-contain">
            </div>
          </div>
        </div>
      </section>

      <section class="bg-white border-4 p-4 lg:p-6 lg:px-10 main-blue-border mb-4">
        <div class="max-w-2xl mx-auto -mt-16 lg:-mt-24 xl:-mt-32 mb-4  lg:mb-8 relative">
          <img src="~@/assets/images/202304/mg-head.png" class="object-contain">
        </div>
        <div class="flex relative items-end lg:-mt-24 justify-end">
          <div class="">
            <img src="~@/assets/images/202304/mg-pop.png" class="object-contain block lg:mb-24">
          </div>
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="p-2" v-for="(item, index) in abcData" :key="index">
              <img :src="item.img_url" class="object-contain">
            </router-link>
          <a href="https://store.liveabc.com/magazine/detail/7725">
            <img src="~@/assets/images/202304/mg-content.png" class="object-contain">
          </a>
          <div class="boy absolute w-1/6">
            <img src="~@/assets/images/202304/mg-kid.png" class="object-contain">
          </div>
        </div>

        <div class="dased-hr my-4"></div>

        <div class="flex items-center">
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="p-2 w-1/5" v-for="(item, index) in planData" :key="index">
            <img :src="item.img_url" class="object-contain">
          </router-link>
        </div>
      </section>

      <section class="relative livepen mb-40 lg:mb-32">
        <a class="flex justify-center px-2 lg:px-20 items-center" href="https://store.liveabc.com/book/detail/6743">
          <div class="w-1/2 p-2 lg:p-6">
            <img src="~@/assets/images/202304/livepen-16g.png" class="object-contain">
          </div>
          <div class="w-1/2 p-2 lg:p-6">
            <img src="~@/assets/images/202304/livepen-content.png" class="object-contain">
          </div>
        </a>
        <div class="absolute left-0 bottom-0 w-10 lg:w-32 kid1">
          <img src="~@/assets/images/202304/livepen-kid1.png" class="object-contain">
        </div>
        <div class="absolute right-0 bottom-0 w-10 lg:w-32 kid2">
          <img src="~@/assets/images/202304/livepen-kid2.png" class="object-contain">
        </div>
      </section>

      <section class="z-20 lg:p-12 xl:p-6 xl:px-10 mb-4 package">
        <a class="max-w-4xl mx-auto z-20 mb-8 flex items-center justify-center -mt-32 px-2" href="https://store.liveabc.com/products/magazine/sale?tag=231" target="_blank">
          <div>
            <img src="~@/assets/images/202304/set-head.png" class="object-contain z-20">
          </div>
          <div class="-ml-5 lg:-ml-12 mt-5">
            <img src="~@/assets/images/202304/set-more.png" class="object-contain z-20">
          </div>
        </a>
        <div class="flex items-center flex-wrap mb-12">
          <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="p-3 w-1/2 lg:w-1/3" v-for="(item, index) in livepen" :key="index">
            <img :src="item.img_url" class="object-contain">
          </router-link>
        </div>
        <a class="max-w-4xl mx-auto z-20 mb-8 flex items-center justify-center px-2"  href="https://store.liveabc.com/products/magazine/sale?tag=232" target="_blank">
          <div>
            <img src="~@/assets/images/202304/kid-head.png" class="object-contain z-20">
          </div>
          <div class="-ml-6">
            <img src="~@/assets/images/202304/kid-more.png" class="object-contain z-20">
          </div>
        </a>
        <div class="flex items-center flex-wrap">
          <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="p-3 w-1/2 lg:w-1/3" v-for="(item, index) in kidsbook" :key="index">
            <img :src="item.img_url" class="object-contain">
          </router-link>
        </div>
      </section>

      <section class="event_text py-6 pb-10 main-text-color text-shadow">
        <div class="container max-w-6xl mx-auto font-semibold px-4 pl-8">
          <h6 class="text-xl lg:text-2xl mb-4 text-center main-blue-dark">注意事項</h6>
          <ul class="list-decimal list-outside leading-loose lg:text-2xl second-blue-dark">
            <li>活動期間購買兒童類叢書單筆訂單滿500元，於訂單成立後即贈送「麥當勞蛋捲冰淇淋即享券」乙張，單筆訂單以贈送乙次為限。「麥當勞蛋捲冰淇淋即享券」為LiveABC向Ticket Xpress即享券企業禮贈平台購買之票券，將於2023.5.15前統一以簡訊方式寄出。活動細節以LiveABC官網公告為主，並保留活動修改及變更權利。</li>
            <li>活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</li>
          </ul>
        </div>
      </section>

      <section>
        <div class="relative">
          <div class="relative z-0">
            <img src="~@/assets/images/202304/head-bg.png" class="object-contain z-0" style="transform: rotate(180deg);">
          </div>
          <router-link :to="{ name: 'index' }" class="flex absolute w-3/5 lg:w-1/2 girls2 justify-center items-center">
            <div class="px-4">
              <img src="~@/assets/images/202304/bottom.png" class="object-contain z-10">
            </div>
            <div class="px-4">
              <img src="~@/assets/images/202304/head-girl.png" class="object-contain z-10">
            </div>
          </router-link>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
export default {
  name: 'April2023',
  metaInfo () {
    return {
      title: '滿額請吃冰🍦｜LiveABC兒童書展超多優惠等你拿',
      titleTemplate: null
    }
  },
  data () {
    return {
      planData: [
        { id: 7726, type: 'live', img_url: require('@/assets/images/202304/mg-live.png') },
        { id: 7727, type: 'all', img_url: require('@/assets/images/202304/mg-all.png') },
        { id: 7728, type: 'cnn', img_url: require('@/assets/images/202304/mg-cnn.png') },
        { id: 7729, type: 'jp', img_url: require('@/assets/images/202304/mg-jp.png') },
        { id: 7724, type: 'hiw', img_url: require('@/assets/images/202304/mg-hiw.png') }
      ],
      abcData: [
        { id: 7725, type: 'hiw', img_url: require('@/assets/images/202304/mg-abc.png') }
      ],
      livepen: [
        { id: 7993, img_url: require('@/assets/images/202304/set-item1.png') },
        { id: 8306, img_url: require('@/assets/images/202304/set-item2.png') },
        { id: 8248, img_url: require('@/assets/images/202304/set-item3.png') },
        { id: 8244, img_url: require('@/assets/images/202304/set-item4.png') },
        { id: 8252, img_url: require('@/assets/images/202304/set-item5.png') },
        { id: 8117, img_url: require('@/assets/images/202304/set-item6.png') }
      ],

      kidsbook: [
        { id: 8286, img_url: require('@/assets/images/202304/kid-item1.png') },
        { id: 7694, img_url: require('@/assets/images/202304/kid-item2.png') },
        { id: 7549, img_url: require('@/assets/images/202304/kid-item3.png') },
        { id: 7268, img_url: require('@/assets/images/202304/kid-item4.png') },
        { id: 5179, img_url: require('@/assets/images/202304/kid-item5.png') },
        { id: 6373, img_url: require('@/assets/images/202304/kid-item6.png') }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.main-blue-dark {
  color: #0b257a;
}
.second-blue-dark {
  color: #3c53ad;
}
.main-blue-border {
  border-color: #0b257a;
}
#april2023 {
  background: #fef7a7;
  .main {
    max-width: 1345px;
  }
  .dased-hr {
    width: 100%;
    height: 2px;
    background-image: linear-gradient(to right, #3c53ad 0%, #3c53ad 20%, transparent 20%);
    background-size: 14px 2px;
    background-repeat: repeat-x;
  }
  .girls {
    top: 45%;
    left: 35%;
    transform: translateY(-50%);
    @media (max-width: 768px) {
      left: 55%;
      transform: translate(-50%, -50%);
    }
  }
  .girls2 {
    top: 45%;
    left: 35%;
    transform: translateY(-50%);
    @media (max-width: 768px) {
      left: 55%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .boy {
    right: 5%;
    bottom: 30%;
    @media (max-width: 768px) {
      right: 2%;
      bottom: 40%;
    }
  }
  .livepen {
    background-size: contain;
    background-image: url('~@/assets/images/202304/livepen-bg.png');
    background-repeat: no-repeat;
    background-origin: center;
    background-position: center;
  }
  .package {
    background: #ffe6a9;
    border-radius: 50px;
  }
}
</style>
